export default {
  computed: {
    mobileLangSwitcher() {
      return this.$store.getters.MOBILE_LANG_SWITCHER;
    },
  },
  methods: {
    setLocale(locale) {
      this.$store.dispatch('SET_MOBILE_LANG_SWITCHER', false);

      //this.$i18n.locale = localStorage.locale = locale;

      if (this.$i18n.locale !== locale) {
        this.$router.push({
          params: {lang: locale},
        });
      }
    },
  },
};
